/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCharterFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type Charter, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/GetCrewBriefing
 */
export interface GetCrewBriefingRequestBuilder extends BaseRequestBuilder<GetCrewBriefingRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Charter[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<GetCrewBriefingRequestBuilderGetQueryParameters> | undefined) : Promise<Charter[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetCrewBriefingRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetCrewBriefingRequestBuilderGetQueryParameters {
    date?: DateOnly;
}
/**
 * Uri template for the request builder.
 */
export const GetCrewBriefingRequestBuilderUriTemplate = "{+baseurl}/Charter/GetCrewBriefing?date={date}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetCrewBriefingRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetCrewBriefingRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCharterFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
